var _g, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignDangerEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Danger_x5F_EU",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M6.002,87.5c-1.267,0-2.401-0.656-3.032-1.755c-0.631-1.1-0.627-2.409,0.011-3.504L44.98,10.235 C45.613,9.148,46.743,8.5,48,8.5s2.387,0.648,3.021,1.735l41.997,72.006c0.639,1.095,0.644,2.404,0.012,3.504 c-0.631,1.099-1.765,1.755-3.031,1.755H6.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M48,9c1.078,0,2.045,0.556,2.588,1.487l41.998,72.006c0.547,0.938,0.551,2.061,0.01,3.003 C92.055,86.438,91.084,87,89.998,87H6.002c-1.086,0-2.057-0.562-2.598-1.504c-0.541-0.942-0.537-2.065,0.01-3.003l41.998-72.006 C45.955,9.556,46.922,9,48,9 M48,8c-1.34,0-2.681,0.661-3.452,1.983L2.55,81.989C0.996,84.654,2.918,88,6.002,88h83.995 c3.084,0,5.006-3.346,3.452-6.011L51.452,9.983C50.681,8.661,49.34,8,48,8L48,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B33229"
    },
    d: "M48,23.868L79.573,78H16.427L48,23.868 M48,9.959c-0.671,0-1.342,0.331-1.728,0.992L4.254,82.992 C3.477,84.326,4.438,86,5.982,86h84.036c1.544,0,2.505-1.674,1.728-3.008L49.728,10.951C49.342,10.289,48.671,9.959,48,9.959 L48,9.959z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 68,
    width: 8,
    height: 8
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,65 46,65 44,35 52,35  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignDangerEu);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_danger_eu.0f903e03bb4790d305a4d8ce83cadd01.svg";
export { ForwardRef as ReactComponent };